export enum EditDataTypesEnum {
  EMPLOYEE,
  HR_BP,
  DATE,
  MONTH_DATE,
  NUMBER,
  TEXT,
  DOUBLE_TEXT,
  DROPDOWN_WITH_COMMENT,
  DROPDOWN,
  MULTI_DROPDOWN,
  BOOLEAN,
  COMMA_SEPARATED_TEXT,
  PERCENTAGE,
  RULE_SET
}
